"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M3.63 0h10.794c.412 0 .745.334.745.745v14.476c0 .41-.334.745-.745.745H2.723a.746.746 0 0 1-.745-.745v-3.395H1v-1h.977V8.49H1v-1h.977V5.155H1v-1h.977V0h1v4.155h.92v1h-.92V7.49h.92v1h-.92v2.336h.92v1h-.92v3.14H14.17V1H3.63V0Zm1.344 6.16h7.706V3.099H4.974V6.16Zm.088 2.323h7.53v-1h-7.53v1Zm0 2.193h7.53v-1h-7.53v1Zm7.53 2.192h-7.53v-1h7.53v1Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M5.519 0h16.298c.517 0 .938.42.938.938v22.125a.94.94 0 0 1-.938.937H3.931a.939.939 0 0 1-.937-.938v-5.39H1.5v-1.125h1.494v-3.973H1.5v-1.125h1.494V7.475H1.5V6.35h1.494V0h1.125v6.35h1.407v1.125H4.119v3.974h1.407v1.125H4.119v3.973h1.407v1.125H4.119v5.203h17.51V1.125H5.52V0Zm2.055 9.014h11.375V4.736H7.574v4.278Zm-.066 3.549h11.507v-1.126H7.508v1.126Zm0 3.35h11.507V14.79H7.508v1.125Zm11.507 3.352H7.508V18.14h11.507v1.125Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M7.358 0H29.09c.689 0 1.25.561 1.25 1.25v29.5c0 .689-.561 1.25-1.25 1.25H5.24c-.689 0-1.25-.561-1.25-1.25v-7.187H2v-1.5h1.99v-5.298H2v-1.5h1.99V9.967H2v-1.5h1.99V0h1.5v8.467h1.876v1.5H5.491v5.298h1.876v1.5H5.491v5.298h1.876v1.5H5.491V30.5H28.84v-29H7.358V0Zm2.74 12.019h15.167V6.314H10.098v5.705Zm-.088 4.731h15.343v-1.5H10.01v1.5Zm0 4.468h15.343v-1.5H10.01v1.5Zm15.343 4.468H10.01v-1.5h15.343v1.5Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M11.036 0h32.41c.93 0 1.688.763 1.688 1.7v44.6c0 .937-.757 1.7-1.688 1.7H7.675a1.696 1.696 0 0 1-1.688-1.7V35.244H3v-1.89h2.987v-8.387H3v-1.89h2.987V14.69H3V12.8h2.987V0h1.875v12.801h2.813v1.89H7.862v8.387h2.813v1.89H7.862v8.387h2.813v1.89H7.862V46.11h35.396V1.89H11.036V0Zm4.11 17.793h22.376V9.546H15.147v8.247Zm-.319 7.152h23.015v-1.89H14.828v1.89Zm0 6.755h23.015v-1.89H14.828v1.89Zm23.015 6.754H14.828v-1.89h23.016v1.89Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M14.715 0h43.213a2.261 2.261 0 0 1 2.25 2.268v59.464A2.261 2.261 0 0 1 57.928 64H10.233a2.261 2.261 0 0 1-2.25-2.268V46.993H4v-2.52h3.983V33.29H4v-2.52h3.983V19.588H4v-2.52h3.983V0h2.5v17.068h3.75v2.52h-3.75V30.77h3.75v2.52h-3.75v11.183h3.75v2.52h-3.75V61.48h47.195V2.52H14.715V0Zm5.48 23.723H50.03V12.727H20.196v10.996Zm-.425 9.537h30.687v-2.52H19.77v2.52Zm0 9.006h30.687v-2.52H19.77v2.52Zm30.687 9.007H19.77v-2.52h30.687v2.52Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconMarketingMaterials = function IconMarketingMaterials(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Marketing Materials' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "MarketingMaterials"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconMarketingMaterials.sizes = [16, 24, 32, 48, 64];
IconMarketingMaterials.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconMarketingMaterials;
exports.default = _default;